var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-pagetop"},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#app'),expression:"'#app'"}],staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/images/icon_pagetop.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }